// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyD8LQ9yARo0u7EIrF1Lkx9qSY69sODCh94",
  authDomain: "upchat-eed11.firebaseapp.com",
  databaseURL: "https://upchat-eed11.firebaseio.com",
  projectId: "upchat-eed11",
  storageBucket: "upchat-eed11.appspot.com",
  messagingSenderId: "685912812556",
  appId: "1:685912812556:web:5d3c52802db8a2aa5a1229",
  measurementId: "G-QX9720691L",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };
